import { MetaApprovalStatusDefinition, WhatsAppContentDefinition } from 'modules/graphql';
import { MediumDataKey } from 'modules/templateEditor/common';
import { FormField } from 'ui/formField';
import { BasicSelect } from 'ui/selects';
import { SettingsReadOnlyText } from '../../common/EditorContentContainer.styled';
import { getIsEditMode } from '../../common/utils';
import { useEditableFieldsContext } from '../../context/EditableFieldsContext';
import { useQueryParamContext } from '../../context/QueryParamContext';
import { SETTINGS_DISPLAY_CONTENT, WHATSAPP_CATEGORY_OPTIONS } from '../constants';
import { useEditableWhatsApp } from '../hooks/useEditableWhatsApp';

export const WHATSAPP_CATEGORY: MediumDataKey = 'category';

export const WhatsAppCategory = () => {
  const { view } = useQueryParamContext();
  const { isEditMode, liveTemplate, setCurrentMediumField } = useEditableFieldsContext();
  const { isEditableWhatsAppTemplate } = useEditableWhatsApp();

  const whatsAppData = (liveTemplate?.mediumData || {}) as WhatsAppContentDefinition;
  // We have category and whatsAppCategory since on load we store the value
  // in whatsAppCategory and in browser updates are stored in category
  // @ts-ignore
  const defaultValue = whatsAppData?.category || whatsAppData?.whatsAppCategory || '';
  const isEditModeVisible = getIsEditMode(view, isEditMode) && isEditableWhatsAppTemplate;

  return (
    <FormField
      isDisabled={whatsAppData.metaApprovalStatus !== MetaApprovalStatusDefinition.NotSubmitted}
      isHorizontalLayout
      labelText={SETTINGS_DISPLAY_CONTENT.category.labelText}
      helpText={isEditModeVisible ? SETTINGS_DISPLAY_CONTENT.category.categoryHelp : null}
    >
      {isEditModeVisible ? (
        <BasicSelect
          data-test="whats-app-select-category"
          defaultValues={[defaultValue]}
          id="whats-app-select-category"
          onSelect={(val) => {
            setCurrentMediumField(WHATSAPP_CATEGORY, val[0]);
          }}
          options={WHATSAPP_CATEGORY_OPTIONS}
          placeholder={SETTINGS_DISPLAY_CONTENT.category.placeholder}
          isFullWidth
        />
      ) : (
        <SettingsReadOnlyText data-test="category-ro">
          {defaultValue || SETTINGS_DISPLAY_CONTENT.unsetText}
        </SettingsReadOnlyText>
      )}
    </FormField>
  );
};
